import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Receipts
    getReceipt: (context, rid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/receipts/" + rid
      return apiUtils.get(path)
    },
    getReceipts: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/receipts"
      return apiUtils.get(path, query)
    },
    createReceipt: (
      context,
      { image, merchantName, currencyCode, paymentAccountId, entryAccountId, date, memo, subtotal, total, taxIds }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/receipts"

      var formData = new FormData()
      if (image != undefined) {
        formData.append("image", image)
      }

      formData.append(
        "data",
        JSON.stringify({
          merchantName,
          currencyCode,
          paymentAccountId,
          entryAccountId,
          date,
          memo,
          subtotal,
          total,
          taxIds
        })
      )

      return apiUtils.post(path, formData)
    },
    updateReceipt: (
      context,
      { id, image, merchantName, currencyCode, paymentAccountId, entryAccountId, date, memo, subtotal, total, taxIds }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/receipts/" + id
      return apiUtils.patch(path, {
        image,
        merchantName,
        currencyCode,
        paymentAccountId,
        entryAccountId,
        date,
        memo,
        subtotal,
        total,
        taxIds
      })
    },
    deleteReceipt: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/receipts/" + id
      return apiUtils.delete(path)
    },
    exportReceipts: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/export-receipts"
      return apiUtils.post(path)
    }
  }
}
